(function ($, window, document) {


window.paraCityTour = function (el) {
  el.onclick = null;
  el.disabled = 'disabled';
  var container = $(el).parents('.paragraph--city-tour-teaser');
  var mapElement = container.find(".map-container")[0];

  loadGmapsApi(function () {
    initMap(mapElement, container.data('data'));
    container.find('.ds-footer').remove();
    $(el).remove();
  });

  var image_map;
  var markers = [];
  function initMap(mapElement, data) {
    var map_content_window = mapElement.parentNode.getElementsByClassName('image-map-content')[0];
    var map_content_window_visible = false;
    map_content_window.style.display = 'none';

    image_map = new google.maps.Map(mapElement, {
      zoom: 14,
      center: {lat: 48.8729788, lng: 9.3773531},
      styles: gmaps_winnenden_style
    });

    //custom Icon
    var markerImage = '/themes/custom/winnenden/images/map-icon.svg';
    //icon on click
    var markerImageClick = '/themes/custom/winnenden/images/map-icon-click.svg';
    // Loop through the results array and place a marker for each
    // set of coordinates.
    var bounds = new google.maps.LatLngBounds();


    function process_data(items) {
      items.forEach(function (item) {
        console.log('item', item);
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(item.lat, item.lng),
          icon: markerImage,
          map: image_map,
        });
        bounds.extend(new google.maps.LatLng(item.lat, item.lng))

        var infowindow = new google.maps.InfoWindow({
          content: "<div class=\"info\"><h5>" + item.title + "</div>",
        });

        //Info Window On Mouseover
        marker.addListener('mouseover', function () {
          //marker.setIcon(markerImageClick);
          infowindow.open(image_map, this);
        });
        marker.addListener('mouseout', function () {
          //marker.setIcon(markerImage);
          infowindow.close();
        });

        marker.addListener('click', function () {
          for (var i = 0; i < markers.length; i++) {
            markers[i].setIcon(markerImage);
          }
          infowindow.open(image_map);
          //marker.setIcon(markerImage);
          marker.setIcon(markerImageClick);
          map_content_window.style.display = 'block';
          map_content_window_visible = true;
          map_content_window.getElementsByTagName('h4')[0].innerHTML = "<a href='" + item.link + "'>" + item.title + "</a>";
          map_content_window.getElementsByClassName('slider-text-container')[0].innerHTML = "<p>" + item.text + "</p>";
          map_content_window.getElementsByClassName('link-to-content')[0].setAttribute('href', item.link);

          if (window.innerWidth < 768) { // TODO isMobile
            setTimeout(function (){

              $("html, body").animate({
                scrollTop: $(map_content_window).offset().top - 50
              }, 350);
            },1)
          }

          var carousel = map_content_window.getElementsByClassName('carousel')[0];
          var spanIndexes = $(carousel).parent().parent().find('.map-slider-controlls .map-slider-counter span');
          spanIndexes.first().html(1);
          spanIndexes.first().next().html(item.images.length);
          var carousel_inner = map_content_window.getElementsByClassName('carousel-inner')[0];
          carousel_inner.innerHTML = "";

          item.images.forEach(
            function (imageItem, index) {
              var additional_class = index === 0 ? " active" : "";
              carousel_inner.innerHTML += '<div class="carousel-item ' + additional_class + '">' + imageItem + '</div>';
            }
          )
          $(carousel).carousel('dispose').carousel().on('slide.bs.carousel slid.bs.carousel', function (ev) {
            if (window.lzi_trigger) window.lzi_trigger();
            var index = $(ev.relatedTarget).index() + 1;
            spanIndexes.first().html(index);
          });

          if (window.lzi_trigger) window.lzi_trigger();
        });

        markers.push(marker);
      });

      //image_map.fitBounds(bounds, {padding: [250, 250]});
      image_map.setCenter(bounds.getCenter());
    }

    if (data) {
      process_data(data);
    }else {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', "/api/map_items");
      xhr.onload = function () {
        if (xhr.status === 200) {
          var data = JSON.parse(xhr.responseText);
          process_data(data);
        }
      };
      xhr.send();
    }

    image_map.addListener("click", function () {
      for (var i = 0; i < markers.length; i++) {
        markers[i].setIcon(markerImage);
      }
      if (map_content_window_visible) {
        map_content_window_visible = false;
        map_content_window.style.display = 'none';
      }
    });
  }
};

}(jQuery, window, document));
